import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import { RealtimeDataProvider } from './contexts/RealtimeDataContext';
import Agenda from './pages/agenda/AgendaPage';
import Clinicas from './pages/clinicas/Clinicas';
import Pacientes from './pages/pacientes/Pacientes';
import Relatorios from './pages/relatorios/Relatorios';
import LoginPage from './pages/login/LoginPage';
import RecebiveisPage from './pages/recebiveis/RecebiveisPage';
import RegisterPage from './pages/criarConta/RegisterPage';
import Atendimento from './pages/atendimento/AtendimentoPage';
import PrivateRoute from './components/routes/PrivateRoute';
import PlanRoute from './components/routes/PlanRoute';
import { LoadingProvider } from './contexts/LoadingContext';
import UserProfile from './pages/userProfile/UserProfile';
import FaqPage from './pages/faq/FaqPage';
import SupportPage from './pages/suporte/SupportPage';
import ContactPage from './pages/contato/ContactPage';
import TelemedicinaPage from './pages/telemedicina/TelemedicinaPage';
import PagamentoRealizado from './pages/pagamento/PagamentoRealizado';
import PagamentoCancelado from './pages/pagamento/PagamentoCancelado';
import PasswordReset from './pages/recuperarSenha/PasswordReset';
import UpgradePage from './pages/upgradePlano/UpgradePage';
import ValidacaoReceitaPage from './pages/validacaoReceitaDigital/ValidacaoReceitaPage';
import { rateLimit } from './services/rateLimitService';
import PrescriptionPage from './pages/prescriptionPage/PrescriptionPage';
import UploadCidTuss from './pages/upload-cid-tuss/UploadCidTuss';
import ConsultaCidTuss from './pages/consultaCidTuss/ConsultaCidTuss';
import CIDSearchPage from './pages/CIDSearch/CIDSearchPage';
import PatientVideoCallPage from './pages/atendimentoPaciente/PatientVideoCallPage';
import ECGAnalysisPage from './pages/analiseECG/ECGAnalysisPage';
import AlertMessage from './components/common/AlertMessage/AlertMessage';
import LaudosPage from './pages/laudos/LaudosPage';
import ConvenioPage from './pages/ConvenioPage/ConvenioPage';
import ConvenioDetails from './pages/ConvenioPage/ConvenioDetails';
import ProntuarioPage from './pages/ProntuarioPage/ProntuarioPage';

const root = ReactDOM.createRoot(document.getElementById('root'));

const AppWrapper = () => {
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage] = useState('');
  const [alertType] = useState('info');
  const [rateLimited, setRateLimited] = useState(false);

  useEffect(() => {
    if (!rateLimit()) {
      setRateLimited(true);
    }
  }, []);

  // Removido 'handleSuccess' já que não está sendo utilizado

  if (rateLimited) {
    return (
      <div>
        Você excedeu o número de requisições permitidas. Tente novamente mais
        tarde.
      </div>
    );
  }

  return (
    <>
      <Routes>
        <Route path="/cadastrar" element={<RegisterPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/validar-receita-digital"
          element={<ValidacaoReceitaPage />}
        />
        <Route path="/pagamento-realizado" element={<PagamentoRealizado />} />
        <Route path="/pagamento-cancelado" element={<PagamentoCancelado />} />
        <Route path="/recuperar-senha" element={<PasswordReset />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <App />
            </PrivateRoute>
          }
        />
        <Route
          path="/pacientes"
          element={
            <PrivateRoute>
              <Pacientes />
            </PrivateRoute>
          }
        />
        <Route
          path="/prescricao"
          element={
            <PrivateRoute>
              <PrescriptionPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/upload-cid-tuss"
          element={
            <PrivateRoute>
              <UploadCidTuss />
            </PrivateRoute>
          }
        />
        <Route
          path="/convenios/:convenioName"
          element={
            <PrivateRoute>
              <ConvenioPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/gerar-laudos-e-guias-tiss"
          element={
            <PrivateRoute>
              <LaudosPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/analise-ecg"
          element={
            <PrivateRoute>
              <ECGAnalysisPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/consulta-tuss"
          element={
            <PrivateRoute>
              <ConsultaCidTuss />
            </PrivateRoute>
          }
        />
        <Route
          path="/consulta-cid"
          element={
            <PrivateRoute>
              <CIDSearchPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/atendimento"
          element={
            <PrivateRoute>
              <Pacientes />
            </PrivateRoute>
          }
        />
        <Route
          path="/plano-premium"
          element={
            <PrivateRoute>
              <UpgradePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/clinicas"
          element={
            <PlanRoute requiredPlan="Premium">
              <Clinicas />
            </PlanRoute>
          }
        />
        <Route
          path="/agenda"
          element={
            <PrivateRoute>
              <Agenda />
            </PrivateRoute>
          }
        />
        <Route
          path="/relatorios"
          element={
            <PlanRoute requiredPlan="Empresarial">
              <Relatorios />
            </PlanRoute>
          }
        />
        <Route
          path="/convenios/:convenioName/detalhes"
          element={
            <PrivateRoute>
              <ConvenioDetails />
            </PrivateRoute>
          }
        />
        <Route
          path="/atendimento-paciente"
          element={
            <PrivateRoute requiresToken={true}>
              <PatientVideoCallPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/recebiveis"
          element={
            <PlanRoute requiredPlan="Premium">
              <RecebiveisPage />
            </PlanRoute>
          }
        />
        <Route
          path="/perfil-de-usuario"
          element={
            <PrivateRoute>
              <UserProfile />
            </PrivateRoute>
          }
        />
        <Route
          path="/ajuda/duvidas-frequentes"
          element={
            <PrivateRoute>
              <FaqPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/ajuda/suporte"
          element={
            <PrivateRoute>
              <SupportPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/ajuda/contato"
          element={
            <PrivateRoute>
              <ContactPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/atendimento/consultorio"
          element={
            <PrivateRoute>
              <Atendimento />
            </PrivateRoute>
          }
        />
        <Route
          path="/prontuario-eletronico"
          element={
            <PrivateRoute>
              <ProntuarioPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/atendimento/telemedicina"
          element={
            <PlanRoute requiredPlan="Empresarial">
              <TelemedicinaPage />
            </PlanRoute>
          }
        />
      </Routes>
      {showAlert && (
        <AlertMessage
          message={alertMessage}
          type={alertType}
          onClose={() => setShowAlert(false)}
        />
      )}
    </>
  );
};

root.render(
  <React.StrictMode>
    <LoadingProvider>
      <RealtimeDataProvider>
        <Router>
          <AppWrapper />
        </Router>
      </RealtimeDataProvider>
    </LoadingProvider>
  </React.StrictMode>
);
